module.exports = __webpack_public_path__ + "static/media/inactive.9a087021.svg";